import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { InvoiceTransmissionStatus } from '../models/invoice-transmission-status.model';

/**
 * O2C private API: InvoiceTransmissionStatusController
 * Base: ${app.path.prefix.url.private}/invoiceTransmissionStatus → o2c-backend/private/invoiceTransmissionStatus
 */
@Injectable({
	providedIn: 'root',
})
export class InvoiceTransmissionStatusService {
	private readonly API_BASE_URL =
		environment.ipserver + 'o2c-backend/private/invoiceTransmissionStatus';

	constructor(private httpClient: HttpClient) {}

	/**
	 * All transmission status rows for the given invoice reference (gemDbKey).
	 */
	public getByInvoiceReference(
		invoiceReference: string | number
	): Observable<InvoiceTransmissionStatus[]> {
		const params = new HttpParams().set(
			'invoiceReference',
			String(invoiceReference)
		);
		return this.httpClient.get<InvoiceTransmissionStatus[]>(
			`${this.API_BASE_URL}/byInvoiceReference`,
			{ params }
		);
	}

	/**
	 * Transmission status rows linked to a document log id (FYF_O2C_DOCUMENT_LOG.id).
	 */
	public getByIdLog(idLog: number): Observable<InvoiceTransmissionStatus[]> {
		const params = new HttpParams().set('idLog', String(idLog));
		return this.httpClient.get<InvoiceTransmissionStatus[]>(
			`${this.API_BASE_URL}/byIdLog`,
			{ params }
		);
	}

	/**
	 * Single row by id. Backend returns 404 if not found (caller should handle error).
	 */
	public getById(id: number): Observable<InvoiceTransmissionStatus> {
		const params = new HttpParams().set('id', String(id));
		return this.httpClient.get<InvoiceTransmissionStatus>(
			`${this.API_BASE_URL}/getById`,
			{ params }
		);
	}

	/**
	 * Full list (intended for tests; can be heavy in production).
	 */
	public list(): Observable<InvoiceTransmissionStatus[]> {
		return this.httpClient.get<InvoiceTransmissionStatus[]>(
			`${this.API_BASE_URL}/list`
		);
	}
}
